import { BaseEntity } from '../../model/base-entity';

export class Lot implements BaseEntity {
    constructor(
        public id?: number,
        public lotId?: number,
        public lotUUID?: string,
        public stockId?: string,
        public gid?: number,
        public mgid?: number,
        public designation?: string,
        public status?: string,
        public locationId?: number,
        public locationName?: string,
        public unitId?: number,
        public unitName?: string,
        public actualBalance?: number,
        public availableBalance?: number,
        public reservedTotal?: number,
        public withdrawalTotal?: number,
        public notes?: string,
        public createdByUsername?: string,
        public createdDate?: string,
        public lastDepositDate?: string,
        public lastWithdrawalDate?: string,
        public pendingDepositsTotal?: number,
        public sourceUid?: string,
        public sourceStockId?: string,
        public attributeTypesValueMap?: any,
        public userId?: string,
        public eType?: string,
        public eId?: any,
        public locId?: any,
        public sourceId?: any,
    ) {
    }
}

export class LotAttribute {
    constructor(
        public id?: number,
        public value?: string,
        public displayValue?: string,
        public variableId?: number,
        public variableName?: string,
        public variableDescription?: string,
        public date?: string,
        public locationId?: string,
        public locationName?: string,
        public hasFiles?: boolean
    ) {
    }
}

export class LotAttributeRequestModel {
    constructor(
        public variableId?: number,
        public value?: string,
        public date?: string,
        public locationId?: number,
    ) {
    }
}

export class ImportLot {
    constructor(public gid?: number,
                public storageLocationAbbr?: string,
                public units?: string,
                public amount?: number,
                public stockId?: string,
                public notes?: string) {

    }
}

export class LotColumnModel {
    constructor(
        public id: string,
        public displayName: string,
        public category: LotColumnCategory,
        public selected: boolean,
        public visible: boolean) {
    }
}

export class LotAttributeColumnModel {
    constructor(
        public id: number,
        public name: string,
        public alias: string) {
    }
}

export enum LotColumnCategory {
    STATIC = 'STATIC',
    ATTRIBUTE = 'ATTRIBUTE'
}

